const tourGenerationBotSettingsModel = vm => ({
  title: vm.$gettext('Tour Generation Bot Settings'),
  endpoint: 'tour-generation-bot-settings',
  allowNew: true,
  allowDelete: true,
  countrize: 'region.country_iso_code',
  fields: [
    {
      key: 'id',
      sortable: true
    },
    {
      key: 'region_id',
      label: vm.$gettext('Region'),
      type: 'select',
      options: 'regions',
      showKey: 'id',
      showField: 'name',
      withSelect: true,
      editable: true,
      sortable: true,
      required: true,
      description: vm.$gettext('To which region does this settings applies to'),
      default: null
    },
    {
      key: 'time_from',
      label: vm.$gettext('Time From'),
      type: 'time',
      editable: true,
      required: true,
      description: vm.$gettext('Time from this settings applies. Format hh:mm:ss'),
      withSeconds: true
    },
    {
      key: 'time_to',
      label: vm.$gettext('Time To'),
      type: 'time',
      editable: true,
      required: true,
      description: vm.$gettext('Time to this settings applies. Format hh:mm:ss'),
      withSeconds: true
    },
    {
      key: 'proximity',
      label: vm.$gettext('Proximity'),
      editable: true,
      description: vm.$gettext('Proximity to add shippings at the beginning or end of the tour'),
      type: 'number',
      step: '0.1'
    },
    {
      key: 'tolerance',
      label: vm.$gettext('Tolerance'),
      editable: true,
      description: vm.$gettext('How much longer a tour could grow after a good one was found'),
      type: 'number',
      step: '0.1'
    },
    {
      key: 'stops_per_km',
      label: vm.$gettext('Stops Per Km.'),
      editable: true,
      required: true,
      description: vm.$gettext('Stops per Km.'),
      type: 'number',
      step: '0.1'
    },
    {
      key: 'min_shippings',
      label: vm.$gettext('Min. Shippings'),
      editable: true,
      description: vm.$gettext('Minimum number of shippings to generate a tour'),
      type: 'integer'
    },
    {
      key: 'max_shippings',
      label: vm.$gettext('Max. Shippings'),
      editable: true,
      description: vm.$gettext('Max number of shippings to generate a tour'),
      type: 'integer'
    },
    {
      key: 'estimated_completion_time',
      label: vm.$gettext('Est. Completion Time'),
      editable: true,
      required: true,
      description: vm.$gettext('Max estimated time for completion in hours'),
      type: 'number',
      step: '0.1'
    }
  ],
  filters: ['id', 'region.name', 'region.country_iso_code'],
  includes: ['region']
})

export default tourGenerationBotSettingsModel
